import React from 'react'

const DoctorsCarouselModal = () => {
  return (
    <div>
      
    </div>
  )
}

export default DoctorsCarouselModal
